export const scrollHandler = () => {
    const offset = window.scrollY;
    const sticky = document.querySelector('.wsmainfull');
    if (!sticky) {
        return;
    }

    if (offset > 80) {
        sticky.classList.add('scroll');
    } else {
        sticky.classList.remove('scroll');
    }
};

export const preventEmptyAnchor = () => {
    const anchors = document.querySelectorAll("a[href='#']");
    anchors.forEach((anchor) => {
        if (anchor.dataset.prevented === 'true') {
            return;
        }

        anchor.dataset.prevented = 'true';
        anchor.addEventListener('click', (event) => {
            event.preventDefault();
        });
    });
};
